import { render, staticRenderFns } from "./JetpackTable.vue?vue&type=template&id=10e9393c"
import script from "./JetpackTable.vue?vue&type=script&lang=js"
export * from "./JetpackTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports